import React from 'react';

const PARTENAIRES = [
  { src: '/part1.png', alt: 'Partenaire Prudens 1' },
  { src: '/part2.png', alt: 'Partenaire Prudens 2' },
  { src: '/part3.png', alt: 'Partenaire Prudens 3' },
  { src: '/part4.png', alt: 'Partenaire Prudens 4' },
  { src: '/part5.png', alt: 'Partenaire Prudens 5' },
  { src: '/part6.png', alt: 'Partenaire Prudens 6' },
  { src: '/part7.png', alt: 'Partenaire Prudens 7' },
  { src: '/part8.png', alt: 'Partenaire Prudens 8' },
  { src: '/part9.png', alt: 'Partenaire Prudens 9' },
  { src: '/part10.png', alt: 'Partenaire Prudens 10' },
];

const QuiSommesNous: React.FC = () => {
  return (
    <div>
      {/* Hero Section - photo */}
      <section className="relative py-24 md:py-28 text-white overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="/residence4.png"
            alt=""
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-prudens-bleu-fonce/70" aria-hidden="true" />
        </div>
        <div className="container-custom relative z-10">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Qui sommes nous ?
          </h1>
          <p className="text-xl max-w-3xl text-white/95">
            Découvrez l'équipe et les valeurs qui font de Prudens un acteur engagé
            de l'économie sociale et solidaire.
          </p>
        </div>
      </section>

      {/* Équipe - photos uniquement pour les co-fondateurs */}
      <section className="py-16 bg-gray-100">
        <div className="container-custom">
          <h2 className="section-title text-center mb-14">Notre équipe</h2>
          
          <div className="max-w-4xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8">
            {/* Vincent Husson */}
            <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6 text-center">
              <div className="w-36 h-36 md:w-40 md:h-40 rounded-full overflow-hidden mx-auto mb-5 bg-gray-100">
                <img
                  src="/VH.jpg"
                  alt="Vincent Husson"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <h3 className="text-lg font-bold text-prudens-bleu-fonce mb-2 tracking-wide">VINCENT</h3>
              <p className="text-prudens-bleu-fonce font-medium text-sm">Co-fondateur</p>
            </div>

            {/* Bastien */}
            <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6 text-center">
              <div className="w-36 h-36 md:w-40 md:h-40 rounded-full overflow-hidden mx-auto mb-5 bg-gray-100">
                <img
                  src="/BTJ.jpg"
                  alt="Bastien"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <h3 className="text-lg font-bold text-prudens-bleu-fonce mb-2 tracking-wide">BASTIEN</h3>
              <p className="text-prudens-bleu-fonce font-medium text-sm">Co-fondateur</p>
            </div>

            {/* Fabrice */}
            <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6 text-center">
              <h3 className="text-lg font-bold text-prudens-bleu-fonce mb-2 tracking-wide">FABRICE</h3>
              <p className="text-prudens-bleu-fonce font-medium text-sm">Directeur Opérationnel</p>
            </div>

            {/* Thibault */}
            <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6 text-center">
              <h3 className="text-lg font-bold text-prudens-bleu-fonce mb-2 tracking-wide">THIBAULT</h3>
              <p className="text-prudens-bleu-fonce font-medium text-sm">Assistant opérationnel</p>
            </div>
          </div>

        </div>
      </section>

      {/* Présentation de la société - discrète, large sur desktop */}
      <section className="py-10 md:py-12 bg-gray-100">
        <div className="container-custom max-w-full px-4 md:px-6 lg:max-w-6xl lg:px-8 mx-auto">
          <div className="max-w-full lg:max-w-none">
            <div className="bg-white/80 backdrop-blur-sm rounded-xl p-5 md:p-6 lg:p-8 mb-8 border border-gray-100 shadow-sm">
              <h2 className="text-xl md:text-2xl font-semibold text-gray-700 text-center mb-6">Prudens en quelques mots</h2>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10 lg:gap-12">
                <div>
                  <h3 className="text-sm font-semibold text-prudens-bleu-fonce mb-3 uppercase tracking-wide">Informations</h3>
                  <ul className="space-y-2 text-sm text-gray-600">
                    <li className="flex items-start">
                      <span className="font-medium text-gray-500 mr-2 min-w-[5rem]">Nom :</span>
                      <span>Prudens</span>
                    </li>
                    <li className="flex items-start">
                      <span className="font-medium text-gray-500 mr-2 min-w-[5rem]">Adresse :</span>
                      <span>87 Rue Saint Aubert, 62000 ARRAS</span>
                    </li>
                    <li className="flex items-start">
                      <span className="font-medium text-gray-500 mr-2 min-w-[5rem]">Statut :</span>
                      <span>ESS (Économie Sociale et Solidaire)</span>
                    </li>
                    <li className="flex items-start">
                      <span className="font-medium text-gray-500 mr-2 min-w-[5rem]">Date de création :</span>
                      <span>18 septembre 2024</span>
                    </li>
                  </ul>
                </div>
                
                <div>
                  <h3 className="text-sm font-semibold text-prudens-bleu-fonce mb-3 uppercase tracking-wide">Engagement ESS</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    Prudens est une Entreprise de l'Economie Sociale et Solidaire qui répond aux obligations de la loi du 31 juillet 2014 sur les ESS. A ce titre, elle est en cours de labellisation ESUS. Elle s'est également dotée d'un Comité Ethique chargé de suivre ses actions et son développement.
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Nos partenaires */}
      <section className="py-16 md:py-20 bg-gray-100">
        <div className="container-custom">
          <h2 className="section-title text-center mb-4">Nos partenaires</h2>
          <p className="text-center text-gray-600 max-w-2xl mx-auto mb-12">
            Ils nous font confiance et accompagnent notre développement.
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-8 md:gap-10 items-center justify-items-center">
            {PARTENAIRES.map((partner, index) => (
              <div
                key={index}
                className="flex items-center justify-center w-full h-24 md:h-28 px-4 transition-opacity duration-300 hover:opacity-100 opacity-80"
              >
                <img
                  src={partner.src}
                  alt={partner.alt}
                  className="max-h-full w-auto object-contain"
                />
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default QuiSommesNous;

